export const memo = (deps, fn) => {
    let value;
    let oldDeps = null;
    return (...a) => {
        const newDeps = deps(...a);
        if (!value) {
            value = fn(...newDeps);
            oldDeps = newDeps;
            return value;
        }
        const match = oldDeps &&
            oldDeps.length === newDeps.length &&
            !oldDeps.some((dep, i) => dep !== newDeps[i]);
        if (match) {
            return value;
        }
        value = fn(...newDeps);
        oldDeps = newDeps;
        return value;
    };
};
export function functionalUpdate(updater, input) {
    return typeof updater === "function"
        ? updater(input)
        : updater;
}
export function makeStateUpdater(key, instance) {
    return (updater) => {
        instance.setState((old) => {
            return Object.assign(Object.assign({}, old), { [key]: functionalUpdate(updater, old[key]) });
        });
    };
}
export const poll = (fn, interval = 100, timeout = 1000) => new Promise((resolve) => {
    let clear;
    const i = setInterval(() => {
        if (fn()) {
            resolve();
            clearInterval(i);
            clearTimeout(clear);
        }
    }, interval);
    clear = setTimeout(() => {
        clearInterval(i);
    }, timeout);
});
